<template>
  <b-modal
    :id="modalId"
    :visible="showModal"
    title="Buscar Producto"
    size="lg"
    @hidden="cerrarModal"
    hide-footer
  >
    <div class="form-row align-items-end">
      <!-- Selector de productos -->
      <div class="col-sm-6">
        <div class="form-group mb-0">
          <label class="col-form-label">Producto:</label>
          <multiselect2
            ref="multiselectProducto"
            v-model="productoSeleccionado"
            track-by="id"
            label="nombre"
            :loading="loadingProductos"
            :internal-search="false"
            placeholder="Buscar producto..."
            :options="productosLista"
            :allow-empty="false"
            :show-labels="false"
            :custom-label="customLabelProduct"
            @search-change="busquedaAsincronaProductos"
            @select="onProductoSeleccionado"
          >
            <span slot="noResult">Sin Resultados</span>
            <span slot="noOptions">Escriba para buscar</span>
            <template slot="option" slot-scope="props">
              {{ props.option.codigo }} - {{ props.option.nombre }}
              <span v-if="props.option.sub_grupo" style="color: red; font-weight: bold">
                - {{ props.option.sub_grupo }}
              </span>
              <span
                v-if="props.option.stock !== undefined"
                style="color: green; font-weight: bold; margin-left: 5px;"
              >
                (Stock: {{ formatearNumero(props.option.stock) }})
              </span>
            </template>
            <template slot="afterList">
              <div class="row" v-if="showCargarMas">
                <a
                  href="javascript:void(0)"
                  class="col-sm-12 pl-5 py-1 text-dark font-weight-bold"
                  @click="cargarMasProductos"
                >
                  Cargar mas...
                </a>
              </div>
            </template>
          </multiselect2>
        </div>
      </div>

      <!-- Stock -->
      <div class="col-sm-2">
        <div class="form-group row mb-0">
          <label class="label mr-3">Stock:</label>
          <div class="align-items-center"
            style="background: transparent; border: none; padding: 0;">
            <span v-if="loadingStock">
              <b-spinner small></b-spinner>
            </span>
            <span
              v-else-if="stockInfo && stockInfo.stock"
              class="badge badge-pill p-2"
              :class="{
                'badge-success': stockActual > 0,
                'badge-danger': stockActual === 0
              }"
              style="font-size: 10px;"
            >
              {{ formatearNumero(stockActual) }}
            </span>
            <span v-else class="badge badge-pill badge-secondary p-2">-</span>
          </div>
        </div>
      </div>

      <!-- Cantidad -->
      <div class="col-sm-2">
        <div class="form-group mb-0">
          <label class="col-form-label">Cantidad:</label>
          <input
            type="text"
            v-model="cantidadFormateada"
            class="form-control"
            @keypress="onlyNumber"
          />
        </div>
      </div>

      <!-- Unidades de medida -->
      <div class="col-sm-2">
        <div class="form-group mb-0">
          <label class="col-form-label d-block">&nbsp;</label>
          <div class="form-control d-flex flex-column justify-content-center"
            style="height: auto; min-height: 38px; border: none;
              background: transparent; padding: 0;">
            <div class="radio-unidad-medida" v-if="stockInfo && stockInfo.stock">
              <b-form-radio
                v-model="tipoUnidad"
                value="principal"
                class="mb-1"
              >
                {{ unidadPrincipalNombre }}
              </b-form-radio>
              <b-form-radio
                v-if="tieneUnidadSecundaria"
                v-model="tipoUnidad"
                value="secundaria"
              >
                {{ unidadSecundariaNombre }}
              </b-form-radio>
            </div>
          </div>
        </div>
      </div>

      <!-- Alerta sin stock -->
      <div class="col-sm-12 mt-2" v-if="sinStock && stockErrorMsg">
        <div class="alert alert-danger py-2 mb-2">
          <small>{{ stockErrorMsg }}</small>
        </div>
      </div>

      <!-- Info del producto seleccionado -->
      <div class="col-sm-12 mt-2" v-if="productoSeleccionado">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Sub Grupo</th>
              <th>Unidad de Medida</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ productoSeleccionado.codigo }}</td>
              <td>{{ productoSeleccionado.nombre }}</td>
              <td>{{ productoSeleccionado.sub_grupo || 'N/A' }}</td>
              <td>{{ productoSeleccionado.unidad_medida || 'Sin unidad' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Botones -->
      <div class="col-sm-12 text-right mt-3">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          @click="cerrarModal"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="confirmarSeleccion"
          :disabled="!puedeAgregar"
        >
          Agregar
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect2 from '@/components/util/vue-multiselect2';
import axios from '@/modules/common/axiosERP';

export default {
  name: 'ModalBuscarProducto',
  components: {
    Multiselect2,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    almacenId: {
      type: [Number, String],
      default: null,
    },
    monedaId: {
      type: [Number, String],
      default: 6,
    },
  },
  data() {
    return {
      productoSeleccionado: null,
      modalId: 'modal-buscar-producto',
      productosLista: [],
      loadingProductos: false,
      cantidad: 1,
      filter: '',
      totalRegistros: 0,
      currentPage: 0,
      delayTimeout: null,
      stockInfo: null,
      loadingStock: false,
      sinStock: false,
      stockErrorMsg: '',
      tipoUnidad: 'principal',
    };
  },
  computed: {
    showModal: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    showCargarMas() {
      return this.totalRegistros > 100 && (this.currentPage * 100) < this.totalRegistros;
    },
    usarUnidadSecundaria() {
      return this.tipoUnidad === 'secundaria';
    },
    stockActual() {
      if (!this.stockInfo || !this.stockInfo.stock) return 0;
      if (this.usarUnidadSecundaria) {
        return Math.round(this.stockInfo.stock.saldo_ua || 0);
      }
      return Math.round(this.stockInfo.stock.saldo_up || 0);
    },
    tieneUnidadSecundaria() {
      if (!this.stockInfo) return false;
      const tieneStock = this.stockInfo.stock && (this.stockInfo.stock.saldo_ua !== undefined);
      const tieneUnidad = this.stockInfo.unidad_medida_alternativa
        || (this.stockInfo.producto && this.stockInfo.producto.unidad_medida_alternativa);
      return !!(tieneStock && tieneUnidad);
    },
    unidadPrincipalNombre() {
      if (this.stockInfo) {
        const um = this.stockInfo.unidad_medida
          || (this.stockInfo.producto && this.stockInfo.producto.unidad_medida);
        if (um && um.descripcion) return um.descripcion;
      }
      return this.productoSeleccionado ? (this.productoSeleccionado.unidad_medida || '') : '';
    },
    unidadSecundariaNombre() {
      if (!this.stockInfo) return '';
      const uma = this.stockInfo.unidad_medida_alternativa
        || (this.stockInfo.producto && this.stockInfo.producto.unidad_medida_alternativa);
      return uma ? (uma.descripcion || '') : '';
    },
    puedeAgregar() {
      return this.productoSeleccionado
        && this.cantidad >= 1
        && this.productoSeleccionado.unidad_medida_id
        && !this.sinStock
        && !this.loadingStock
        && this.stockInfo
        && this.stockInfo.stock
        && this.stockActual > 0;
    },
    cantidadFormateada: {
      get() {
        return this.formatearNumero(this.cantidad);
      },
      set(value) {
        const numero = parseInt(value.replace(/\./g, ''), 10) || 0;
        this.cantidad = numero;
      },
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$bvModal.show(this.modalId);
          this.limpiarSeleccion();
          this.cargarProductosInicial();
        });
      } else {
        if (this.$refs.multiselectProducto) {
          this.$refs.multiselectProducto.deactivate();
        }
        this.$nextTick(() => {
          this.$bvModal.hide(this.modalId);
        });
      }
    },
    tipoUnidad() {
      this.validarStockActual();
    },
  },
  beforeDestroy() {
    if (this.$refs.multiselectProducto) {
      this.$refs.multiselectProducto.deactivate();
    }
  },
  methods: {
    limpiarSeleccion() {
      this.productoSeleccionado = null;
      this.cantidad = 1;
      this.productosLista = [];
      this.filter = '';
      this.currentPage = 0;
      this.stockInfo = null;
      this.sinStock = false;
      this.stockErrorMsg = '';
      this.tipoUnidad = 'principal';
    },
    validarStockActual() {
      if (this.stockInfo && this.stockInfo.stock) {
        if (this.stockActual === 0) {
          this.sinStock = true;
          this.stockErrorMsg = 'El producto no dispone de stock para esta fecha.';
        } else {
          this.sinStock = false;
          this.stockErrorMsg = '';
        }
      }
    },
    async cargarProductosInicial() {
      this.currentPage = 1;
      this.loadingProductos = true;
      try {
        const params = {
          page: 1,
          perPage: 100,
          filterKey: '',
        };
        const response = await axios.get('/configuration/tipoProducto/combo', { params });
        const { data } = response.data;
        this.productosLista = data.data || data;
        this.totalRegistros = data.total || 0;
      } catch (error) {
        console.error('Error cargando productos:', error);
      } finally {
        this.loadingProductos = false;
      }
    },
    async buscarProductos(query) {
      this.filter = query;
      this.currentPage = 1;
      this.loadingProductos = true;
      try {
        const params = {
          page: 1,
          perPage: 100,
          filterKey: this.filter,
        };
        const response = await axios.get('/configuration/tipoProducto/combo', { params });
        const { data } = response.data;
        this.productosLista = data.data || data;
        this.totalRegistros = data.total || 0;
      } catch (error) {
        console.error('Error buscando productos:', error);
      } finally {
        this.loadingProductos = false;
      }
    },
    busquedaAsincronaProductos(query) {
      const DELAY = 400;
      clearTimeout(this.delayTimeout);
      this.delayTimeout = setTimeout(() => this.buscarProductos(query), DELAY);
    },
    async cargarMasProductos() {
      this.currentPage += 1;
      this.loadingProductos = true;
      try {
        const params = {
          page: 1,
          perPage: 100 * this.currentPage,
          filterKey: this.filter,
        };
        const response = await axios.get('/configuration/tipoProducto/combo', { params });
        const { data } = response.data;
        this.productosLista = data.data || data;
        this.totalRegistros = data.total || 0;
      } catch (error) {
        console.error('Error cargando más productos:', error);
      } finally {
        this.loadingProductos = false;
      }
    },
    customLabelProduct({ codigo, nombre }) {
      return `${codigo} - ${nombre}`;
    },
    onProductoSeleccionado(producto) {
      this.productoSeleccionado = producto;
      this.stockInfo = null;
      this.sinStock = false;
      this.stockErrorMsg = '';
      this.tipoUnidad = 'principal';
      this.cargarStockProducto(producto.id);
    },
    cargarStockProducto(productoId) {
      if (!this.almacenId) {
        return;
      }
      this.loadingStock = true;
      const fecha = new Date().toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      const params = {
        almacen_id: this.almacenId,
        producto_id: productoId,
        fecha,
        moneda_id: this.monedaId,
      };
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      axios.get('/inventario/traspaso_producto/producto/stock_lotes', { params })
        .then((response) => {
          const { data: respData } = response;
          if (respData.status === 'ERROR' || respData.error) {
            this.stockInfo = null;
            this.sinStock = true;
            this.stockErrorMsg = respData.message || 'El producto no dispone de stock para esta fecha.';
            return;
          }
          this.stockInfo = respData.data;
          this.sinStock = false;
          this.stockErrorMsg = '';
          this.validarStockActual();
        })
        .catch((error) => {
          this.stockInfo = null;
          this.sinStock = true;
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'El producto no dispone de stock para esta fecha.';
          this.stockErrorMsg = msg;
        })
        .finally(() => {
          this.loadingStock = false;
        });
    },
    confirmarSeleccion() {
      if (this.productoSeleccionado && this.cantidad >= 1) {
        let unidadMedidaId = this.productoSeleccionado.unidad_medida_id;
        let unidadMedida = this.productoSeleccionado.unidad_medida || '';
        let unidadMedidaAbreviatura = this.productoSeleccionado.unidad_medida_abreviatura || unidadMedida;

        if (this.usarUnidadSecundaria && this.tieneUnidadSecundaria) {
          const prod = this.stockInfo && this.stockInfo.producto;
          const uma = (this.stockInfo && this.stockInfo.unidad_medida_alternativa)
            || (prod && prod.unidad_medida_alternativa);
          if (uma) {
            unidadMedidaId = uma.id
              || this.productoSeleccionado.unidad_medida_alternativa_id
              || unidadMedidaId;
            unidadMedida = uma.descripcion || this.productoSeleccionado.unidad_medida_alternativa || '';
            unidadMedidaAbreviatura = uma.abreviatura || uma.descripcion
              || this.productoSeleccionado.unidad_medida_alternativa || '';
          } else if (this.productoSeleccionado.unidad_medida_alternativa_id) {
            unidadMedidaId = this.productoSeleccionado.unidad_medida_alternativa_id;
            unidadMedida = this.productoSeleccionado.unidad_medida_alternativa || '';
            unidadMedidaAbreviatura = this.productoSeleccionado.unidad_medida_alternativa || '';
          }
        }

        const productoParaTabla = {
          medicamento_id: this.productoSeleccionado.id,
          medicamento_nombre: this.productoSeleccionado.nombre,
          cantidad: this.cantidad,
          unidad_medida_id: unidadMedidaId,
          unidad_medida: unidadMedida,
          unidad_medida_abreviatura: unidadMedidaAbreviatura,
          codigo: this.productoSeleccionado.codigo,
          usar_unidad_secundaria: this.usarUnidadSecundaria,
          conversiones: this.stockInfo?.producto?.conversiones || 1,
        };
        this.$emit('seleccionar', productoParaTabla);
        this.cerrarModal();
      }
    },
    cerrarModal() {
      if (this.$refs.multiselectProducto) {
        this.$refs.multiselectProducto.deactivate();
      }
      this.limpiarSeleccion();
      this.$nextTick(() => {
        this.$emit('update:modelValue', false);
      });
    },
    onlyNumber(event) {
      const tecla = event.which || event.keyCode;
      if ((tecla < 48 || tecla > 57) && tecla !== 46) {
        event.preventDefault();
      }
    },
    formatearNumero(numero) {
      const num = parseInt(numero, 10) || 0;
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
  },
};
</script>

<style scoped>
::v-deep .radio-unidad-medida .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #fdd835;
  border-color: #fdd835;
}
::v-deep .radio-unidad-medida .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
::v-deep .radio-unidad-medida .custom-control-label::before {
  border-color: #fdd835;
}
</style>
